import { useState, useEffect } from 'react'

/** Light/dark theme backed by localStorage + the `dark` class on <html>.
 *  Initial application happens in index.html (before paint) to avoid a flash. */
export function useTheme() {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains('dark'))
  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark)
    localStorage.setItem('theme', dark ? 'dark' : 'light')
  }, [dark])
  return [dark, setDark] as const
}
